import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import FilterItems from "./FilterItems";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FilterItems2 from "./FilterItems2";
import FilterListIcon from '@mui/icons-material/FilterList';



export default function Filter(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

 
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div style={{}}>
      <FilterListIcon className="filter-menus" size="small" onClick={handleClick} />
      <Popover
        id={id}

        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          elevation: 2,
          sx: {
            overflow: 'visible',
            border: '1px solid #fff',
            borderRadius: '5px',
            mt: 1,
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 2,
              left: 'calc(50% - 6px)',
              width: 12,
              height: 12,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            mt: "5px",
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              width: 6,
              height: 1,
              top: 5,
              transform: "rotate(45deg)",
              border: "1px solid #ff0000",
              left: "calc(50% - 6px)"

            }
          }}
        />
        <Typography sx={{ mt: 0, p: 0, width: "280px !important" }}>
          {/* <FilterItems /> */}
          <FilterItems2 columnList={props.columnList}
            filteredColumns={props.filteredColumns} filteredCoumns
            currentColumn={props.currentColumn}
            columnToggleHandler={props.columnToggleHandler}
            applyFilterHandler={props.applyFilterHandler}
            clearFilterHandler={props.clearFilterHandler}
          />
        </Typography>
      </Popover>
    </div>
  );
}
